export default __webpack_public_path__ + "img/6a2e91680e1461a4ea647421f15f1a07.png";